import { message } from 'antd';
import { RecordInfoDrawer } from 'components/RecordInfoDrawer';
import { TableHeader } from 'components/TableHeader';
import { DELETE_ERROR, FETCH_ERROR, SUCCESS_DELETE } from 'constants/alerts';
import { useDocumentTitle } from 'hooks/useDocumentTitle';
import { useDrawers } from 'hooks/useDrawers';
import { useHeaderChanger } from 'hooks/useHeaderChanger';
import { usePagination } from 'hooks/usePagination';
import { React, useEffect, useState, useCallback } from 'react';
import { KBKService } from 'services/KBKService';
import { KBKForm } from './KBKForm';
import { KBKTable } from './KBKTable';

function KBK() {
  useDocumentTitle('КБК');
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(false);
  const { setCount } = useHeaderChanger('КБК');
  const {
    state: { drawerVisible, formIsActive, activeRecord },
    openDrawer,
    closeDrawer,
    openCreateForm,
    openEditForm,
    closeForm,
  } = useDrawers();
  const { page, perPage, totalRows, setPagination, setTotalRows } =
    usePagination();

  const fetchItems = useCallback(async () => {
    if (!page || !perPage) {
      return;
    }

    setLoading(true);

    try {
      const { items, total } = await KBKService.getKBK({ page, perPage });
      setItems(items);
      setCount(total);
      setTotalRows(total);
    } catch (err) {
      message.error(FETCH_ERROR);
    } finally {
      setLoading(false);
    }
  }, [page, perPage]);

  useEffect(() => fetchItems(), [fetchItems]);

  const handleDelete = async () => {
    try {
      const isDeleted = await KBKService.deleteKBK(activeRecord.id);

      if (isDeleted) {
        closeDrawer();
        fetchItems();
        message.success(SUCCESS_DELETE);
      }
    } catch (err) {
      message.error(DELETE_ERROR);
    }
  };

  return (
    <>
      <TableHeader onCreate={openCreateForm} pageId="kbk" />

      <KBKTable
        items={items}
        loading={loading}
        current={page}
        pageSize={perPage}
        onRowClick={openDrawer}
        total={totalRows}
        onChange={setPagination}
      />

      <RecordInfoDrawer
        record={activeRecord}
        drawerTitle={activeRecord?.name}
        recordFields={[
          { label: 'Наименование', key: 'name' },
          { label: 'Код', key: 'code' },
        ]}
        isVisible={drawerVisible}
        onClose={closeDrawer}
        onEdit={openEditForm}
        onDelete={handleDelete}
        deleteConfirmText="Вы точно хотите удалить эту запись ?"
        pageId="kbk"
      />

      <KBKForm
        isActive={formIsActive}
        initialValues={activeRecord}
        onSuccess={fetchItems}
        onClose={closeForm}
      />
    </>
  );
}

export { KBK };
